import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';

export const ChartContainer = styled.div`
width: 100%;
height: 400px;
position: relative;
  .header {
    display: flex;
    align-items: center;
    font-size: 17px !important;
    justify-content: center;
    font-weight: bold;
    margin-bottom: 20px;
    gap: 10px;
  }
  .title {
    font-size: 17px !important;    
    font-weight: bold;
    margin-right: 10px;
  }
 .basic {
  margin-left: 30px;
  width: calc(100% - 30px);
  margin-top: 20px;
 }
 .arrow-left {
  font-size: 2em !important;
  z-index: 48;
  cursor: pointer;
  i {
    background: white !important;
    padding-top: 5px !important;
    border-radius: 50% !important;
  }
 }
 .arrow-right {
  z-index: 48;
  font-size: 2em !important;
  cursor: pointer;
  i {
    background: white !important;
    padding-top: 5px !important;
    border-radius: 50% !important;
  }
 }
`
export const StyledHeader = styled.div`
display: flex;
align-items: baseline;
 .title {
  font-size: 21px !important;
 }
`

export const TooltipWrapper = styled.div`
margin: 0;
border: 1px solid #f5f5f5;
background-color: #f3f4f5;
border-radius: 10px;
padding: 5px;
`
export const StyledFiltersOptions = styled(Dropdown)`
font-size: 1.2rem !important;
 .divider.text {
  margin: 0.45238095em 0 0.45238095em -1em !important; 
 }
 .menu.transition {
   margin-left: -6em !important;
    .item {
      padding: 0px !important;
    }
 }

 .ui.checkbox {
   padding : .78571429rem 1.14285714rem !important;
   width: 100%;
 }
`

export const StyledFilterWrapper = styled.div`
display: flex;
align-items: baseline;
justify-content: end;
flex-wrap: wrap;
gap: 10px;
margin-bottom: 10px;
`

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  input {
    width: 220px !important;
  }
  .ui.selection.dropdown {
    width: 220px !important;
    .divider.text {
      max-width: 180px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .ui.selection.active.dropdown .menu {
    width: 220px !important;
  }
`